import React, {FC} from 'react';
import {GxButton, GxIcon, GxInput, GxPhoneInput} from '@garpix/garpix-web-components-react';
import cnBind from 'classnames/bind';
import styles from '../../styles/index.module.scss';
import {PhoneIcon} from '../../../../assets';
import SelectStaff from '../SelectStaff';

interface ITabGroupsUser {
    flag: boolean;
    openModalCall: (phone: string)=>void;
    handleClickTab: (name: string)=>void;
    formik: any,
}
const cn = cnBind.bind(styles);

const TabGroupsUser:FC<ITabGroupsUser> = ({flag,openModalCall,handleClickTab,formik}) => {

    return (
        <div className={cn({
            'tab-group': true,
            'tab-group--active': flag
        })}>
            <div className={styles['tab-group--container']}>
                <h2>Контрагент</h2>
                <p className={styles['tab-group--action']}
                   onClick={() => handleClickTab('usersTab')}>{flag ? 'Свернуть' : 'Развернуть'}</p>
            </div>
            <div className={cn(styles['form'], styles['tab-group--item'])}>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                    <span className={cn(styles['label'])}>Контрагент:</span>
                    <SelectStaff
                        value={formik.values.client}
                        onChangeSelect={(selectedOption: any) => {
                            formik.setFieldValue('client', selectedOption && selectedOption);
                            formik.setFieldValue('phone', selectedOption && selectedOption.phone)
                            formik.setFieldValue('email', selectedOption && selectedOption.email)
                            formik.setFieldValue('client_name', selectedOption && `${selectedOption.last_name} ${selectedOption.first_name} ${selectedOption.patronymic_name}`);
                            if(!selectedOption) formik.setFieldValue('phone', '')
                        }}
                    />
                </div>
                <div className={styles['form--item']}>
                    <div className={styles['form--container']}>
                        <label htmlFor="phone" className={styles['phone']}>
                            <span>Телефон:</span>
                            <GxPhoneInput
                                country='ru'
                                className={styles['phone--input']}
                                value={formik.values.phone}
                                onGx-change={(phone: any) => formik.setFieldValue('phone', phone.detail.value)}
                            />
                        </label>
                        <GxButton className={styles['btn']} onClick={()=>openModalCall(formik.values.phone)}>
                            <GxIcon src={PhoneIcon} className={styles['btn--icon']} />
                        </GxButton>
                    </div>
                </div>
                <div className={styles['form--item']}>
                    <GxInput
                        label='Email:'
                        className={cn(styles['form--input'], styles['form--input__wrap'])}
                        value={formik.values.email}
                        onGx-change={(e: Record<string, any>) => formik.setFieldValue('email', e.target.value)}
                    />
                </div>
                <div className={styles['form--item']}>
                    <GxInput
                        label='Имя:'
                        className={cn(styles['form--input'], styles['form--input__wrap'])}
                        value={formik.values.client_name}
                        onGx-change={(e: Record<string, any>) => formik.setFieldValue('client_name', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
};

export default TabGroupsUser;